import RequestService from '@/service'

// 注册用户
export function apiLoginRegister(data: { mobile: string; password: string; code: string }) {
  return RequestService.post({
    url: '/chain/user/create',
    data,
    isCloseFullLoading: true
  })
}

/**
 * 发送验证码
 * @param data.mobile // 19836752590
 * @param data.scene // 0 会员用户 - 用户注册, (1,  "会员用户 - 手机号登陆")、(2, "会员用户 - 修改手机")、(3, "会员用户 - 修改密码")、(4, "会员用户 - 忘记密码")、(21, "后台用户 - 手机号登录")
 */
export function apiLoginSendCode(data: { mobile: string; scene: string }) {
  return RequestService.post({
    url: '/chain/user/send-sms-code',
    data,
    isCloseFullLoading: true
  })
}

// 使用账号密码登录 --->  username: 手机号，password：密码
export function apiLoginPassword(data: { username: string; password: string }) {
  return RequestService.post({
    url: '/chain/user/login',
    data,
    isCloseFullLoading: true
  })
}

// 使用 手机号 + 验证码 登录  --->  mobile: 手机号，code：验证码
export function apiLoginCode(data: { mobile: string; code: string }) {
  return RequestService.post({
    url: '/chain/user/sms-login',
    data,
    isCloseFullLoading: true
  })
}
